class TbrManualFilterGroup extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;

    this.dataset.ready = 'true';
    this.paramName = this.dataset.param || '';
    this.handleChange = this.handleChange.bind(this);
    this.handlePopState = this.syncFromUrl.bind(this);

    this.addEventListener('change', this.handleChange);
    window.addEventListener('popstate', this.handlePopState);

    this.syncFromUrl();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.handleChange);
    window.removeEventListener('popstate', this.handlePopState);
  }

  selectedValuesFromUrl() {
    if (!this.paramName) return [];

    const url = new URL(window.location.href);
    return url.searchParams
      .getAll(this.paramName)
      .flatMap((value) => value.split(','))
      .map((value) => value.trim())
      .filter(Boolean);
  }

  syncFromUrl() {
    const selected = this.selectedValuesFromUrl();
    const inputs = [...this.querySelectorAll('input[type="checkbox"]')];

    inputs.forEach((input) => {
      input.checked = selected.includes(input.value);
    });

    const status = this.querySelector('[data-tbr-manual-status]');
    if (!status) return;

    if (selected.length === 1) {
      status.textContent = selected[0];
    } else if (selected.length > 1) {
      status.textContent = String(selected.length);
    } else {
      status.textContent = '';
    }
  }

  handleChange(event) {
    const target = event.target;
    if (!(target instanceof HTMLInputElement) || target.type !== 'checkbox') return;
    if (!this.contains(target) || !this.paramName) return;

    const url = new URL(window.location.href);
    const checked = [...this.querySelectorAll('input[type="checkbox"]:checked')];

    url.searchParams.delete(this.paramName);
    checked.forEach((input) => url.searchParams.append(this.paramName, input.value));
    url.searchParams.delete('page');

    window.location.assign(url.toString());
  }
}

if (!customElements.get('tbr-manual-filter-group')) {
  customElements.define('tbr-manual-filter-group', TbrManualFilterGroup);
}
